export default "<!-- Menu bar -->\n<app-menu-bar-rsvn></app-menu-bar-rsvn>\n"